import { useCallback } from 'react';
import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { Carrier, formatCarrier, GET_CARRIERS } from '../OrgLevelSelector/useGetCarriers.query';

const useCreateCarrierQuery = (
  onSuccess: (carrier: Carrier) => void,
  onError: (externalId: string) => void
) => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading } = useMutation(
    (value: Carrier) =>
      api.post(API_URL.CARRIERS, {
        name: value.name,
        external_id: value.externalId,
      }),
    {
      onSuccess: ({ data }) => {
        onSuccess(formatCarrier(data));
        queryClient.invalidateQueries({
          queryKey: [GET_CARRIERS],
        });
      },
      // TODO: Fix type
      // @ts-ignore
      onError: ({ response: { data } }, config: Carrier) => {
        if (data?.elevate_error_message?.includes('already exists')) {
          onError(config.externalId);
        }
      },
    }
  );

  const handleSave = useCallback(
    async (value: Carrier) => {
      await mutateAsync(value);
    },
    [mutateAsync]
  );

  return {
    isLoading,
    create: handleSave,
  };
};

export default useCreateCarrierQuery;
